import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { LargeMessageComponent } from '../components/large-message/large-message.component';

interface DialogInteface {
  message: string;
  severity: string;
  title?: string;
  url?: string;
}

@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  constructor(private readonly dialog: MatDialog) { }

  openLargeMessage(data: DialogInteface) {

    this.dialog.open(LargeMessageComponent, {
      panelClass: 'largeDialog',
      data: {
        message: data.message,
        title: data.title,
        severity: data.severity,
        url: data.url
      },
      width: "600px",
      position: {
        top: '5%',
        left: '5%'
      }
    })

  }

}
